'use strict';

(function() {
    var util = angular.module('gymsystem.util');

    var openRBookingOnStart;
    if(document.location.hash.substring(0, 5) == '#/rb/') {
        openRBookingOnStart = Number(document.location.hash.substring(5));
    }

    util.factory('resourceBooking', ['$rootScope', 'server', '$modal', '$http', '$filter', '$q', function($rootScope, server, $modal, $http, $filter, $q) {
        var self = {};

        if(openRBookingOnStart) {
            setTimeout(function() {
                self.openById(openRBookingOnStart);
            }, 100);
        }

        self.get = function(rbookingId) {
            return $q.promise(function(resolve, reject) {
                $http.post('/api/resourcebooking/get_with_sibling', {
                    resourcebooking_id: rbookingId
                }).then(function(response) {
                    $rootScope.waitFor(['staffs', 'resourcebookingcategories', 'resourcebookingservices', 'trainingcardtypes', 'members']).then(function() {
                        var rbookings = response.data.bookings;
                        $rootScope.transformResourceBookings(rbookings);
                        var rbooking = _.findWhere(rbookings, {id: rbookingId});
                        rbooking.payment_details = response.data.payment_details;
                        resolve(rbooking);
                    });
                }, reject);
            });
        };

        self.openById = function(rbookingId) {
            return $rootScope.waitFor(['staffs', 'resourcebookingcategories', 'resourcebookingservices', 'trainingcardtypes', 'members']).then(function() {
                return self.get(rbookingId).then(function(rbooking) {
                    return $modal.open({
                        templateUrl: 'views/rbooking.html',
                        controller: 'ResourceBookingModalCtrl',
                        resolve: {
                            rbooking: function() {
                                return rbooking;
                            }
                        }
                    });
                });
            });
        };

        self.showBookingList = function(rbookingList) {
            $modal.open({
                templateUrl: 'components/resourcebooking/rblist.html',
                controller: 'RBListModal',
                resolve: {
                    rbookingList: function() {
                        return rbookingList;
                    }
                }
            });
        };

        self.slotForCalendar = function(data) {
            const rbservice = $rootScope.getPointerById(data.rbservice_id, $rootScope.resourcebookingservices);

            data.enableCapacity = rbservice?.enable_capacity;
            data.allresources = [$rootScope.getMember(data.resource_id)];
            data.staffs = data.allresources;
            data.subTitle = rbservice?.name || data.rbservice_name;
            data.backgroundColor = rbservice?.category?.color;

            if (data.other_service) {
                data.className = data.className ? data.className + ' otherServiceSlot' : 'otherServiceSlot';
            }

            // Use getter to get name of member. Allows us to dynamically update the name (Speedy)
            Object.defineProperty(data, 'title', {
                get: function() {
                    const member = $rootScope.getMember(data.resource_booking[0].user_id);
                    let title = member?.name || $filter('translate')('Person was removed');

                    if (data?.capacity > 1) {
                        title += ` (${data.amount}/${data.capacity})`;
                    }

                    const note = data.resource_booking.find(rb => rb.note);
                    if (note) {
                        title += ' *';
                    }

                    return title;
                }
            });

            return data;
        };

        return self;
    }]);

})();
